import {Injectable, Injector} from '@angular/core';
import {ApiResponse, BaseApiService} from '../../base-api.service';
import {EbitdaModelService} from '../../../Models/Finances/Ebitda/ebitda-model.service';
import {EbitdaFilters} from '../../../../Models/Finances/Ebitda/ebitda-filters.model';

@Injectable({
  providedIn: 'root'
})
export class EbitdaApiService extends BaseApiService {

  constructor(
    protected override injector: Injector,
    public model: EbitdaModelService,
  ) {
    super(injector);
  }


  /**
   * Obtener datos EBITDA
   *
   */
  public getReportEbitda(params: EbitdaFilters | null, save: boolean = true): Promise<ApiResponse> {

    return new Promise((resolve, reject) => {

      return this.httpCall('getResumenEbitaForApp', params).subscribe({
        next: (response) => {
          if (save) {
            this.model.save(response.data);
          }

          resolve(response);
        },
        error: (err: Error) => {
          reject(err);
        }
      });

    });

  }


  /**
   * Obtener datos gráfica EBITDA
   *
   */
  public getCharEbitda(params: EbitdaFilters | null): Promise<ApiResponse> {

    return new Promise((resolve, reject) => {

      return this.httpCall('getEstadisticasGeneralesEbitdaForApp', params).subscribe({
        next: (response) => {
          resolve(response);
        },
        error: (err: Error) => {
          reject(err);
        }
      });

    });

  }


  /**
   * Obtener datos detalle EBITDA
   *
   */
  public getEbitdaDetail(params: EbitdaFilters | null): Promise<ApiResponse> {

    return new Promise((resolve, reject) => {

      return this.httpCall('getResumenEbitaDetallesForApp', params).subscribe({
        next: (response) => {
          resolve(response);
        },
        error: (err: Error) => {
          reject(err);
        }
      });

    });

  }

}
